
import { Outlet } from 'react-router-dom'
import Header from '../components/Header/Header'
import Footer from '../components/Footer/Footer'

const FrontendLayout = () => {

  return (
    <div className='container border bg-ash py-2 my-2'>
       <Header/>
            <main className='py-3'>
               <Outlet/>   
            </main> 
       <Footer/>
    </div>
  )
}

export default FrontendLayout